export default __webpack_public_path__ + "static/media/background.982216a3.jpg";